import * as React from "react";
import { useCallback, useContext } from "react";
import { useFormikContext } from "formik";
import styled from "styled-components";
import TimeRangePresetDropdown from "views/components/searchbar/time-range-filter/TimeRangePresetDropdown";
import { isTimeRange, isTypeRelative } from "views/typeGuards/timeRange";
import { IfPermitted } from "components/common";
import SaveTimeRangeAsPresetButton from "views/components/searchbar/time-range-filter/time-range-picker/SaveTimeRangeAsPresetButton";
import TimeRangeInputSettingsContext from "views/components/contexts/TimeRangeInputSettingsContext";
import { classifyRelativeTimeRange } from "views/components/searchbar/time-range-filter/time-range-picker/RelativeTimeRangeClassifiedHelper";
import { ButtonToolbar } from "components/bootstrap";
const Container = styled(ButtonToolbar)`
  float: right;
  margin-top: 6px;
`;
const normalizePresetTimeRange = (timeRange) => {
  if (isTypeRelative(timeRange)) {
    return classifyRelativeTimeRange(timeRange);
  }
  return timeRange;
};
const TimeRangePresetRow = ({ limitDuration }) => {
  const { showAddToQuickListButton } = useContext(TimeRangeInputSettingsContext);
  const { showPresetsButton } = useContext(TimeRangeInputSettingsContext);
  const { values, setValues } = useFormikContext();
  const { activeTab, timeRangeTabs } = values;
  const onSetPreset = useCallback(
    (newTimeRange) => {
      setValues({
        ...values,
        timeRangeTabs: {
          ...values.timeRangeTabs,
          [newTimeRange.type]: normalizePresetTimeRange(newTimeRange)
        },
        activeTab: newTimeRange.type
      });
    },
    [setValues, values]
  );
  return /* @__PURE__ */ React.createElement(Container, null, showAddToQuickListButton && isTimeRange(timeRangeTabs[activeTab]) && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement(SaveTimeRangeAsPresetButton, null)), showPresetsButton && /* @__PURE__ */ React.createElement(TimeRangePresetDropdown, { limitDuration, onChange: onSetPreset }));
};
export default TimeRangePresetRow;
